/* eslint-disable no-undef */
__webpack_nonce__ = window.NONCE_ID;